export default __webpack_public_path__ + "static/media/efh_icon.f53f3584.svg";